import { computed } from 'vue'
import { router } from '@inertiajs/vue3'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem'
import { ACTOR_TYPE, ROLE } from '@/shared/data/permissionSystem'

// A mentor has two profiles, the mentor and the mentee. The page shows which
// one is on with a colour: purple for Mentor, ink for Mentee. The sidebar
// card cover, the line at the top of the page and the phone chip read it
// from here. A member with no mentor profile has one mode and no colour.
export const useProfileMode = () => {
  const { accessControl } = usePermissionSystem()

  const hasTwoProfiles = computed(
    () => accessControl.value.role === ROLE.MENTOR,
  )
  const isMenteeMode = computed(
    () => accessControl.value.actorType === ACTOR_TYPE.MENTEE,
  )

  const switchMode = () => {
    router.patch('/switch-actor')
  }

  return { hasTwoProfiles, isMenteeMode, switchMode }
}
